import { cn } from "../../lib/utils";

const Button = ({
  variant = "primary",
  size = "md",
  children,
  className,
  ...rest
}) => {
  const baseStyles = "font-medium transition-colors duration-200 inline-flex items-center justify-center gap-2 rounded-xl focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-carex-500";

  const variants = {
    primary:
      "bg-carex-600 text-white hover:bg-carex-700 active:bg-carex-800",
    // Accent bronze — réservé aux actions premium / mises en avant (jamais dominant)
    accent:
      "bg-bronze-500 text-white hover:bg-bronze-600 active:bg-bronze-700",
    secondary:
      "bg-white border border-slate-300 text-slate-700 hover:bg-slate-50 active:bg-slate-100",
    danger:
      "bg-red-600 text-white hover:bg-red-700 active:bg-red-800",
    ghost:
      "text-slate-700 hover:bg-slate-100 active:bg-slate-200",
  };

  const sizes = {
    sm: "px-3 py-1.5 text-sm",
    md: "px-4 py-2 text-sm",
    lg: "px-6 py-3 text-base",
  };

  return (
    <button
      className={cn(baseStyles, variants[variant], sizes[size], className)}
      {...rest}
    >
      {children}
    </button>
  );
};

export default Button;
